export const EMPTY_REVOCATION_COUNTS = Object.freeze({
  actual_resources: 0,
  deleted: 0,
  retained: 0,
  not_collected: 0,
  pending: 0,
  retry: 0,
  manual_review: 0,
  system_evidence: 0,
});

export function normalizeRevocation(record) {
  const revocation = record?.revocation || {};
  return {
    available: Boolean(revocation.available),
    state: String(revocation.state || record?.processing_state || 'ACTIVE').toUpperCase(),
    outcome: String(revocation.outcome || ''),
    processing_restricted: Boolean(
      revocation.processing_restricted
      || record?.processing_restricted
      || record?.is_deleted,
    ),
    requested_at: revocation.requested_at || null,
    completed_at: revocation.completed_at || null,
    next_retention_expiry: revocation.next_retention_expiry || null,
    has_legal_hold: Boolean(revocation.has_legal_hold),
    report_acknowledged: Boolean(revocation.report_acknowledged),
    counts: { ...EMPTY_REVOCATION_COUNTS, ...(revocation.counts || {}) },
    actions: {
      can_view_pii: Boolean(record?.actions?.can_view_pii ?? revocation?.actions?.can_view_pii),
      can_view_documents: Boolean(record?.actions?.can_view_documents ?? revocation?.actions?.can_view_documents),
      can_view_retained_pii: Boolean(record?.actions?.can_view_retained_pii ?? revocation?.actions?.can_view_retained_pii),
      can_view_retained_documents: Boolean(record?.actions?.can_view_retained_documents ?? revocation?.actions?.can_view_retained_documents),
      can_view_governance: true,
      can_view_audit_trail: true,
    },
    items: Array.isArray(revocation.items) ? revocation.items : [],
  };
}

export function lifecycleLabel(value) {
  const state = String(value || 'ACTIVE').toUpperCase();
  return {
    ACTIVE: 'Active',
    REVOCATION_REQUESTED: 'Revocation requested',
    REVOCATION_PROCESSING: 'Revocation processing',
    RETRY_REQUIRED: 'Retry required',
    REVOCATION_FAILED: 'Retry required',
    MANUAL_REVIEW_REQUIRED: 'Manual review required',
    REVOKED: 'Revoked',
    DELETED: 'Revoked · deleted',
    RETAINED_RESTRICTED: 'Revoked · retained and restricted',
    PARTIALLY_RETAINED: 'Revoked · partially retained',
  }[state] || state.replaceAll('_', ' ').toLowerCase();
}

export function lifecycleTone(value) {
  const state = String(value || '').toUpperCase();
  if (state === 'ACTIVE') return 'success';
  if (['RETRY_REQUIRED', 'REVOCATION_FAILED'].includes(state)) return 'danger';
  if (['MANUAL_REVIEW_REQUIRED', 'REVOCATION_PROCESSING', 'REVOCATION_REQUESTED'].includes(state)) return 'warning';
  return 'neutral';
}

export function piiAccessScope(record) {
  const revocation = normalizeRevocation(record);
  if (revocation.actions.can_view_pii) return 'active';
  if (revocation.actions.can_view_retained_pii) return 'retained';
  return '';
}

export function canOpenPII(record) {
  return Boolean(piiAccessScope(record));
}

export function documentAccessScope(record, document) {
  if (document?.is_deleted || String(document?.lifecycle_state || '').toUpperCase() === 'DELETED') {
    return '';
  }

  const hasRecordContext = Boolean(record && (record.actions || record.revocation));
  const actions = normalizeRevocation(record || {}).actions;

  if (document?.can_view === true && (!hasRecordContext || actions.can_view_documents)) {
    return 'active';
  }
  if (
    document?.can_view_retained === true
    && (!hasRecordContext || actions.can_view_retained_documents)
  ) {
    return 'retained';
  }
  return '';
}

export function canOpenDocument(record, document) {
  return Boolean(documentAccessScope(record, document));
}
